/**
 * Select component style classes
 * Centralized styles for all Select-related components
 */

export const selectStyles = {
  content: {
    // z-[60] ensures Select content appears above Dialog overlay (z-50) when nested inside dialogs
    base: "relative z-[60] max-h-96 w-[var(--radix-select-trigger-width)] min-w-[8rem] overflow-hidden rounded-input border border-dinnerplate-white bg-off-white font-inter text-off-black shadow-soft",
    animations: {
      open: "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
      closed: "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
      slide: {
        bottom: "data-[side=bottom]:slide-in-from-top-2",
        left: "data-[side=left]:slide-in-from-right-2",
        right: "data-[side=right]:slide-in-from-left-2",
        top: "data-[side=top]:slide-in-from-bottom-2",
      },
    },
    popper: {
      translate: "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
    },
  },

  viewport: {
    base: "p-2",
    popper: "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]",
  },

  // Matches DropdownListItem: grey at rest; the highlighted (pointer or keyboard)
  // and the checked row both take dinnerplate-white-light with off-black text.
  item: "relative flex w-full cursor-pointer select-none items-center rounded-lg p-4 font-inter text-sm font-normal text-grey outline-none transition-colors duration-100 ease-out data-[highlighted]:bg-dinnerplate-white-light data-[highlighted]:text-off-black data-[state=checked]:bg-dinnerplate-white-light data-[state=checked]:text-off-black data-[disabled]:pointer-events-none data-[disabled]:opacity-50",

  label: "py-1.5 pl-4 pr-4 text-sm font-semibold",

  separator: "-mx-1 my-1 h-px bg-dinnerplate-white",
} as const;

/**
 * Helper function to build SelectContent className
 */
export function getSelectContentClasses(position: "popper" | "item-aligned" = "popper"): string {
  const { content } = selectStyles;
  const classes = [
    content.base,
    content.animations.open,
    content.animations.closed,
    content.animations.slide.bottom,
    content.animations.slide.left,
    content.animations.slide.right,
    content.animations.slide.top,
  ];

  if (position === "popper") {
    classes.push(content.popper.translate);
  }

  return classes.join(" ");
}

/**
 * Helper function to build SelectViewport className
 */
export function getSelectViewportClasses(position: "popper" | "item-aligned" = "popper"): string {
  const { viewport } = selectStyles;
  const classes = [viewport.base];

  if (position === "popper") {
    classes.push(viewport.popper);
  }

  return classes.join(" ");
}

